import { validateEmail } from "../utilities/utils";
import { useState } from "react";

function Register(props) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState({
    value: "",
    isTouched: false,
  });

  const getIsFormValid = () => {
    return firstName && validateEmail(email) && password.value.length >= 8;
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword({
      value: "",
      isTouched: false,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Account created!");
    clearForm();
  };

  const PasswordErrorMessage = () => {
    return (
      <p className="FieldError">Password should have at least 8 characters</p>
    );
  };

  const onLoginClick = () => {
    props.setIsLogin(true);
  };

  return (
    // <div className="Login-Card">
    <form className="Form-Register" onSubmit={handleSubmit}>
      <fieldset className="Fieldset-Register">
        <div className="Login-Card">
          <div className="Login-Title">Register</div>
          <br />
          <div className="Login-Input">
            <input
              value={firstName}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
              placeholder="First name"
              className="Input-Box"
            />
          </div>
          <br />
          <div className="Login-Input">
            <input
              value={lastName}
              onChange={(e) => {
                setLastName(e.target.value);
              }}
              placeholder="Last name"
              className="Input-Box"
            />
          </div>
          <br />
          <div className="Login-Input">
            <input
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="Email address *"
              className="Input-Box"
            />
          </div>
          <br />
          <div className="Login-Input">
            <input
              value={password.value}
              type="password"
              onChange={(e) => {
                setPassword({ ...password, value: e.target.value });
              }}
              onBlur={() => {
                setPassword({ ...password, isTouched: true });
              }}
              placeholder="Password *"
              className="Input-Box"
            />
            {password.isTouched && password.value.length < 8 ? (
              <PasswordErrorMessage />
            ) : null}
          </div>
          <br />
          <div className="Login-Buttons">
            <input
              className="Input-Button"
              type="submit"
              disabled={!getIsFormValid()}
              value="Create account"
            />
            <input
              className="Input-Button"
              type="button"
              onClick={() => onLoginClick()}
              value="Back to Login"
            />
          </div>
        </div>
      </fieldset>
    </form>
    // </div>
  );
}
export default Register;
